import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import CurrencyFormat from "react-currency-format";
import reseller from "web/assets/images/reseller.png";
import premium_star from "web/assets/images/premium_star.png";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "styled-components";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";
import { useHistory } from "react-router-dom";
import Spinner from "web/components/Spinner";
import Button from "web/components/Button";
import Timmer from "web/components/Timmer";
import AlertModal from "web/components/AlertModal";
// import PalletsImg from "web/assets/images/pallet-home-image.webp";
import PalletsImg from 'web/assets/images/pallet-home-image.jpg';
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderOutlinedIcon from "@material-ui/icons/FavoriteBorderOutlined";

import UploadDummy from "web/assets/images/UploadDummy.png";

import { postNeedSearchById, favoriteIconAPI } from "redux/actions/postLoad";

import PlaceBid from "./PlaceBid";
import PlaceAltBid from "./PlaceAltBid";

import RecurrenceModal from "./RecurrenceModal";
import styles from "../details.module.scss";
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import { downloadFile } from "redux/actions/helper/downloadFile";

const NeedDetails = ({ pageId, postType, pageLanguageContents }) => {
  const [response, setResponse] = useState(undefined);
  let history = useHistory();
  const dispatch = useDispatch();
  const cardExpiryDetails = useSelector(
    (state) => state.authReducer.cardExpiryDetails
  );
  const urlObject = useSelector((state) => state.urlParameters.details);

  const fileUrl = process.env.REACT_APP_API_URL + "/user/image/";
  const [placeBidModal, setPlaceBidModal] = useState(false);
  const togglePlaceBidModal = () => setPlaceBidModal(!placeBidModal);

  const [loginType, setLoginType] = useState(false);

  const [makeOfferModal, setMakeOfferModal] = useState(false);
  const toggleMakeOfferModal = () => setMakeOfferModal(!makeOfferModal);

  const [recurrenceModal, setRecurrenceModal] = useState(false);
  const toggleRecurrenceModal = () => setRecurrenceModal(!recurrenceModal);

  const [btnDisable, setBtnDisable] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const token = localStorage.getItem("token");

  let officeDaysArr = ["M", "T", "W", "Th", "F", "Sat", "Sun"];

  const [dayOfWeeks, setDayOfWeeks] = useState(officeDaysArr);
  const [officeHour, setOfficeHour] = useState({
    officeHourStart: "",
    officeHourEnd: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setOfficeHour({
      officeHourStart: tConvert(deliveryWindowBegin),
      officeHourEnd: tConvert(deliveryWindowEnd),
    });
  }, []);
  let currentTimeBegin = new Date();
  currentTimeBegin.setHours(8);
  currentTimeBegin.setMinutes(0);

  let beginHours = currentTimeBegin.getHours();
  let beginMinutes = currentTimeBegin.getMinutes();
  let beginCurrentTime = beginHours + ":" + beginMinutes;

  let currentTimeEnd = new Date();
  currentTimeEnd.setHours(17);
  currentTimeEnd.setMinutes(0);

  let endHours = currentTimeEnd.getHours();
  let endMinutes = currentTimeEnd.getMinutes();
  let endCurrentTime = endHours + ":" + endMinutes;

  let deliveryWindowBegin = beginCurrentTime;
  let deliveryWindowEnd = endCurrentTime;

  let deliveryWindowBeginArr = deliveryWindowBegin.split(":");
  if (deliveryWindowBeginArr.length && deliveryWindowBeginArr[1]) {
    let setHours = deliveryWindowBeginArr[0];
    let setMinutes = deliveryWindowBeginArr[1];
    if (deliveryWindowBeginArr[0].length === 1) {
      setHours = 0 + deliveryWindowBeginArr[0];
    }
    if (deliveryWindowBeginArr[1].length === 1) {
      setMinutes = 0 + deliveryWindowBeginArr[1];
    }
    deliveryWindowBegin = setHours + ":" + setMinutes;
  }
  let deliveryWindowEndArr = deliveryWindowEnd.split(":");

  if (deliveryWindowEndArr.length && deliveryWindowEndArr[1]) {
    let setHours = deliveryWindowEndArr[0];
    let setMinutes = deliveryWindowEndArr[1];
    if (deliveryWindowEndArr[0].length === 1) {
      setHours = 0 + deliveryWindowEndArr[0];
    }
    if (deliveryWindowEndArr[1].length === 1) {
      setMinutes = 0 + deliveryWindowEndArr[1];
    }
    deliveryWindowEnd = setHours + ":" + setMinutes;
  }
  const tConvert = (time) => {
    if (time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1);

        time[3] = undefined // removing the seconds
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        // time[3] = +"";
        // time[2] = +"";
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join("");
    }
  };

  const fetchMyAPI = async ({ pageId, postType }) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(postNeedSearchById(pageId, token));
      if (response.success) {
        if (response.data) {
          // even if post is not available, post created user and bidded user should be able to view the post
          let isPostCreatedUser = false, isBiddedUser = false
          let loggedInLocation = localStorage.getItem('locationID')
          isPostCreatedUser = response.data?.postedUserDetails?.locationsId?.filter(val => val === loggedInLocation)?.length > 0 ? true : false

          if (urlObject?.prevPage === 'bid' && response.data?.status === 'ACCEPTED') isBiddedUser = true

          let obj = {
            id: urlObject?.id?.toString(),
            postType: 'PostLoad',
          }
          dispatch({ type: 'DETAILS', payload: obj })

          let obj1 = {
            title: '',
            params: 'true',
            pageType: "PostLoad",
            expanded: 'sideBar'
          }
          dispatch({ type: 'SEARCH_POST', payload: obj1 })

          // if (response.data.status !== 'AVAILABLE' && response.data.status !== 'PENDING_HANDSHAKE') {
          if ((response.data.status !== 'AVAILABLE' && response.data.status !== 'PENDING_HANDSHAKE') && (!isPostCreatedUser && !isBiddedUser)) {
            setModalContent("This post is no longer available. Check out others on the marketplace.");
            setModalLink(postType === "PostInventory" ? "/nearby-inventory" : "/nearby-needs");
            toggleModal();
          } else {
            setResponse(response.data);

            if (response?.data?.postedUserDetails?.locationsId?.includes(localStorage.getItem("locationID"))) {
              setLoginType(true);
            }
            if (response?.data?.shippingAddress?.locationDaysOfOperations) {
              let dayArr = [];
              for (let i = 0; i < response?.data?.shippingAddress?.locationDaysOfOperations.length; i++) {
                if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "MONDAY") {
                  dayArr.push("M");
                } else if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "TUESDAY") {
                  dayArr.push("T");
                } else if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "WEDNESDAY") {
                  dayArr.push("W");
                } else if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "THURSDAY") {
                  dayArr.push("Th");
                } else if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "FRIDAY") {
                  dayArr.push("F");
                } else if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "SATURDAY") {
                  dayArr.push("Sat");
                } else if (response?.data?.shippingAddress?.locationDaysOfOperations[i] === "SUNDAY") {
                  dayArr.push("Sun");
                }

                if (response?.data?.shippingAddress?.locationDaysOfOperations.length - 1 === i) {
                  setDayOfWeeks(dayArr);
                }
              }
            }

            setOfficeHour({
              ...officeHour,
              officeHourStart: tConvert(response?.data?.appointmentStartTime),
              officeHourEnd: tConvert(response?.data?.appointmentEndTime),
            });

            if (response.data.status === "BIDDING_CLOSE") {
              setBtnDisable(true);
            }
          }
        }
      } else if (response?.error?.message === "You are not authorized to view this post") {
        setModalContent(response?.message);
        setModalLink(postType === "PostInventory" ? "/nearby-inventory" : "/nearby-needs");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  //fetch need details
  useEffect(() => {
    if (pageId && postType) fetchMyAPI({ pageId, postType })
  }, [pageId, postType])

  let requestDate = "NA";
  if (response?.requestedDate) {
    // requestDate = moment(response.requestDeliveryDate).format("MM/DD/YYYY");
    // requestDate= moment(new Date(response?.requestedDate * 1000).toLocaleString()).format(FORMAT)

    let epoch = response?.requestedDate
    let date = new Date(epoch * 1000);
    requestDate = moment(date).format(FORMAT)
  }
  let daysOfWeek = [];

  const addTofavorite = async (response) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let isFavoriteFlag = true;
      if (response?.favorite) {
        isFavoriteFlag = false;
      }

      let data = {
        postId: response?.id,
        postType: "NEED",
        isFavorite: isFavoriteFlag,
      };

      let addToFavoriteResponse = await dispatch(favoriteIconAPI(data, token));
      if (addToFavoriteResponse?.success) {
        setModalContent(addToFavoriteResponse?.data?.msg);
        setModalLink("");
        toggleModal();

        fetchMyAPI({ pageId, postType });
        if (addToFavoriteResponse?.data) {
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const vehiclePreferencesFun = (vehiclePreferences) => {
    let vehicles = "";
    if (vehiclePreferences.includes("FLAT_BED")) {
      vehicles = "Flatbed";
    }
    if (vehiclePreferences.includes("VAN") && vehicles.length > 0) {
      vehicles = vehicles + ", Van";
    } else if (vehiclePreferences.includes("VAN")) {
      vehicles = "Van";
    }
    if (vehiclePreferences.includes("STRAIGHT") && vehicles.length > 0) {
      vehicles = vehicles + ", Straight Truck";
    } else if (vehiclePreferences.includes("STRAIGHT")) {
      vehicles = "Straight Truck";
    }
    return vehicles;
  };

  let condition = [];
  if (response) {
    for (let i = 0; i < response?.palletDetails?.condition?.length; i++) {
      condition.push(response?.palletDetails?.condition[i]);
    }
  }

  let newConditionType
  if (response?.palletDetails?.newConditionType) {
    if (response?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
    else if (response?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
  }

  let dropLive = "";
  if (response?.unLoadingReq === "LIVE_UNLOAD") {
    dropLive = "Live";
  } else if (response?.unLoadingReq !== "LIVE_UNLOAD") {
    dropLive = "Drop";
  }
  let lots = "";
  if (response && response.quantity) lots = response.quantity / 540;
  var radixPos = String(lots).indexOf(".");
  if (radixPos !== -1) {
    lots = parseInt(lots) + parseInt(1);
  }

  const generatePdfDocument = async (imagePath) => {
    // const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
    // window.open(fileUrl);
    dispatch(downloadFile(imagePath));
  };

  const ratingSection = () => {
    if (response?.postedUserDetails?.fcMember) {
      return (
        <RatingSection>
          <div>{pageLanguageContents?.PalletDetails[5]?.Rating}</div>{" "}
          <Box component="fieldset" mb={3} borderColor="transparent">
            <Rating
              readOnly
              name="simple-controlled"
              value={5}
              onChange={(event, newValue) => { }}
            />
          </Box>
        </RatingSection>
      );
    } else {
      return (
        <RatingSection>
          <div>{pageLanguageContents?.PalletDetails[5]?.Rating}</div>{" "}
          <Box component="fieldset" mb={3} borderColor="transparent">
            <Rating
              name="simple-controlled"
              readOnly
              onChange={(event, newValue) => { }}
            />
          </Box>
        </RatingSection>
      );
    }
  };

  const deliveryAppointment = () => {
    if (response?.shippingMode === "DELIVERY") {
      if (response?.appointmentType === "DELIVERY_WINDOW") {
        return (
          <>
            <h3>
              {tConvert(response?.appointmentStartTime)} {response?.appointmentEndTime && "To "}
              {tConvert(response?.appointmentEndTime)}
            </h3>
            <p>Delivery Window</p>
          </>
        );
      } else {
        return (
          <>
            <h3>{tConvert(response?.appointmentStartTime)}</h3>
            <p>Requested Delivery Appointment</p>
          </>
        );
      }
    }
  };

  const postLoadBtns = () => {
    if (!loginType) {
      return (
        <>
          {placeBidLoadBtn(response)}
          {makeOfferLoadBtn(response)}
        </>
      );
    }
  };

  const placeBidLoadBtn = (response) => {
    let bidPlaced = true;
    let getID = response?.postedUserDetails?.locationsId.find(
      (locationId) => locationId === localStorage.getItem("locationID")
    );

    if (!getID) {
      return (
        <div
          onClick={(e) => {
            if (!btnDisable) togglePlaceBidModal();
          }}
        >
          <Button
            type="app-green-button"
            disabled={btnDisable || cardExpiryDetails.sellerCardExpired}
          >
            Place Bid
          </Button>
        </div>
      );
    } else {
      if (!bidPlaced) {
        return <p>Bid Already Made</p>;
      }
    }
  };
  const makeOfferLoadBtn = (response) => {
    let getID = response?.postedUserDetails?.locationsId.find(
      (locationId) => locationId === localStorage.getItem("locationID")
    );

    if (!getID) {
      return (
        <div
          onClick={(e) => {
            if (!btnDisable) toggleMakeOfferModal();
          }}
        >
          <Button
            type="app-green-button"
            disabled={btnDisable || cardExpiryDetails.sellerCardExpired}
          >
            Place Alternative Bid
          </Button>
        </div>
      );
    }
  };

  const deliveryAvailableAttach = () => {
    if (response?.shippingMode === 'DELIVERY') {
      return <h3>{vehiclePreferencesFun(response?.vehiclePreferences)}</h3>;
    } else {
      return <h3>Pickup</h3>;
    }
  };

  const requestDateAttach = () => {
    let type = "Requested Delivery Date";
    if (response?.shippingMode !== 'DELIVERY') {
      type = "Requested Pickup Date";
    }

    if (response?.requestedDate) {
      return (
        <>
          <h3>{moment(response?.requestedDate).format(FORMAT)}</h3>
          <p>{type}</p>
        </>
      );
    } else {
      return (
        <>
          <h3>{pageLanguageContents?.PalletDetails[15]?.NA}</h3>
          <p>{type}</p>
        </>
      );
    }
  };

  const dropLiveAttach = () => {
    if (dropLive) {
      return <h3>{dropLive}</h3>;
    } else {
      return <h3>{pageLanguageContents?.PalletDetails[15]?.NA}</h3>;
    }
  };

  const capitalize = (s) => {
    if (typeof s !== 'string')
      return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const getCommodity = () => {
    let commodityVal = "NA";
    if (response?.palletDetails?.palletType) commodityVal = capitalize(response?.palletDetails?.palletType.toLowerCase())
    else if (response?.palletDetails?.material === 'PLASTIC') commodityVal = 'Plastic'
    else if (response?.palletDetails?.material === 'OTHER') commodityVal = 'Custom'
    return (
      <div>
        <h3>{commodityVal}</h3>
        <p>{pageLanguageContents?.PalletDetails[10]?.Commodity}</p>
      </div>
    );
  };

  const getGradeName = () => {
    let gradeName = "NA";
    if (response?.palletDetails?.grade) {
      gradeName = response?.palletDetails?.grade;
    }

    return (
      <>
        {
          <div>
            <h3>{gradeName}</h3>
            <p>{pageLanguageContents?.PalletDetails[11]?.Grade}</p>
          </div>
        }
      </>
    );
  };
  const isHeatTreared = () => {
    let isHeatTrearedVal = "No";
    if (response?.palletDetails?.heatTreared) {
      isHeatTrearedVal = "Yes";
    }
    return (
      <div className="pl-md-2 pl-sm-0">
        <h3>{isHeatTrearedVal}</h3>
        <p>Heat Treated</p>
      </div>
    );
  };
  const gradeSize = () => {
    let commodityDim = "NA";
    if (
      response?.palletDetails?.length &&
      response?.palletDetails?.width &&
      response?.palletDetails?.height
    ) {
      let length = response?.palletDetails?.length;
      let width = "x" + response?.palletDetails?.width;
      let height = "x" + response?.palletDetails?.height;

      commodityDim = length + "" + width + "" + height;
      if (
        !response?.palletDetails?.length &&
        !response?.palletDetails?.width &&
        !response?.palletDetails?.height
      ) {
        commodityDim = "NA";
      }
    } else {
      if (response?.palletDetails?.size) {
        commodityDim = response?.palletDetails?.size;
      }
      else {
        if (response?.palletDetails?.grade) {
          commodityDim = response?.palletDetails?.grade;
        }
      }
    }
    return (
      <div>
        <h3>{commodityDim}</h3>
        <p>Size</p>
      </div>
    );
  };
  const recurrenceTag = () => {
    let dayOfWeekVal = "";
    if (
      response?.orderRecurrence &&
      response?.orderRecurrence?.pattern &&
      response?.orderRecurrence?.pattern?.dayOfWeek
    ) {
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "MONDAY") {
        dayOfWeekVal = "M";
      }
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "TUESDAY") {
        dayOfWeekVal = " T";
      }
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "WEDNESDAY") {
        dayOfWeekVal = " W";
      }
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "THURSDAY") {
        dayOfWeekVal = " Th";
      }
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "FRIDAY") {
        dayOfWeekVal = " F";
      }
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "SATURDAY") {
        dayOfWeekVal = " Sat";
      }
      if (response?.orderRecurrence?.pattern?.dayOfWeek === "SUNDAY") {
        dayOfWeekVal = " Sun";
      }
    }

    daysOfWeek = [];

    if (
      response?.orderRecurrence &&
      response?.orderRecurrence?.pattern &&
      (response?.orderRecurrence?.pattern?.type === "WEEKLY" ||
        response?.orderRecurrence?.pattern?.type === "RELATIVEMONTHLY" ||
        response?.orderRecurrence?.pattern?.type === "MONTHLY")
    ) {
      for (let i = 0; i < response?.orderRecurrence?.pattern?.daysOfWeek.length; i++) {
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === "MONDAY") {
          daysOfWeek.push("M");
        }
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === "TUESDAY") {
          daysOfWeek.push(" T");
        }
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === "WEDNESDAY") {
          daysOfWeek.push(" W");
        }
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === "THURSDAY") {
          daysOfWeek.push(" Th");
        }
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === "FRIDAY") {
          daysOfWeek.push(" F");
        }
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === "SATURDAY") {
          daysOfWeek.push(" Sat");
        }
        if (response?.orderRecurrence.pattern?.daysOfWeek[i] === "SUNDAY") {
          daysOfWeek.push(" Sun");
        }
      }
    }

    if (
      response?.orderRecurrence &&
      response?.orderRecurrence?.pattern
    ) {
      return (
        <TimeSection>
          <>
            <div className="flow-column">
              {/* <p>{pageLanguageContents?.PalletDetails[35]?.Mode}</p> */}
              {response?.orderRecurrence?.pattern?.type === "DAILY" && (
                <h3>
                  Daily,&nbsp;
                  {response?.orderRecurrence?.range?.endAfterOccurrences ? (
                    "After " +
                    response?.orderRecurrence?.range?.endAfterOccurrences +
                    " Recurrences"
                  ) : (
                    <>
                      {"Starting  " +
                        moment(response?.orderRecurrence?.range?.start).format(
                          "MM/DD/YYYY"
                        )}
                      ,{" "}
                      {"Ending " +
                        moment(response?.orderRecurrence?.range?.endBy).format(
                          "MM/DD/YYYY"
                        )}
                    </>
                  )}
                </h3>
              )}
              {response?.orderRecurrence?.pattern?.type === "WEEKLY" && (
                <h3>
                  Weekly,&nbsp;Every&nbsp;{daysOfWeek.join(",")},&nbsp;
                  {response?.orderRecurrence?.range?.endAfterOccurrences ? (
                    "After " +
                    response?.orderRecurrence?.range?.endAfterOccurrences +
                    " Recurrences"
                  ) : (
                    <>
                      {"Starting  " +
                        moment(response?.orderRecurrence?.range?.start).format(
                          "MM/DD/YYYY"
                        )}
                      ,{" "}
                      {"Ending " +
                        moment(response?.orderRecurrence?.range?.endBy).format(
                          "MM/DD/YYYY"
                        )}
                    </>
                  )}
                </h3>
              )}
              {response?.orderRecurrence?.pattern?.type === "MONTHLY" && (
                <h3>
                  Monthly,&nbsp;
                  {daysOfWeek.length !== 0 ? (
                    <>Every&nbsp;{daysOfWeek.join(",")}</>
                  ) : (
                    <>{response?.orderRecurrence?.pattern?.dayOfMonth}th</>
                  )}
                  &nbsp;
                  {response?.orderRecurrence?.range?.endAfterOccurrences ? (
                    "After " +
                    response?.orderRecurrence?.range?.endAfterOccurrences +
                    " Recurrences"
                  ) : (
                    <>
                      {"Starting  " +
                        moment(response?.orderRecurrence?.range?.start).format(
                          "MM/DD/YYYY"
                        )}
                      ,{" "}
                      {"Ending " +
                        moment(response?.orderRecurrence?.range?.endBy).format(
                          "MM/DD/YYYY"
                        )}
                    </>
                  )}
                </h3>
              )}
              {response?.orderRecurrence?.pattern?.type === "RELATIVEMONTHLY" && (
                <h3>
                  Monthly,&nbsp;
                  {response?.orderRecurrence?.pattern?.dayOfWeek && (
                    <>Every&nbsp;{dayOfWeekVal}</>
                  )}
                  &nbsp;
                  {response?.orderRecurrence?.range?.endAfterOccurrences ? (
                    "After " +
                    response?.orderRecurrence?.range?.endAfterOccurrences +
                    " Recurrences"
                  ) : (
                    <>
                      {"Starting  " +
                        moment(response?.orderRecurrence?.range?.start).format(
                          "MM/DD/YYYY"
                        )}
                      ,{" "}
                      {"Ending " +
                        moment(response?.orderRecurrence?.range?.endBy).format(
                          "MM/DD/YYYY"
                        )}
                    </>
                  )}
                </h3>
              )}
              <p>
                {pageLanguageContents?.PalletDetails[36]?.RecurrenceSchedule}
              </p>
            </div>
          </>
        </TimeSection>
      );
    }
  };
  const specficationDocFiles = () => {
    if (response?.specificationFiles) {
      return (
        <>
          {response?.specificationFiles.map((spectItems, i) => (
            <Tooltip
              placement="top"
              arrow
              title={spectItems?.orignalFileName}
              enterTouchDelay={0}
            >
              <UploadSpec
                className="upload"
                onClick={() => {
                  generatePdfDocument(spectItems?.fileName);
                }}
              >
                <img src={UploadDummy} alt="upload Dummy" />
                <span style={{ cursor: 'pointer' }}>{spectItems?.orignalFileName}</span>
              </UploadSpec>
            </Tooltip>
          ))}
        </>
      );
    } else if (response.specificationFile) {
      return (
        <>
          {response.specificationFile.map((spectItems, i) => (
            <Tooltip
              placement="top"
              arrow
              title={spectItems.fileName}
              enterTouchDelay={0}
            >
              <UploadSpec
                className="upload"
                onClick={() => {
                  generatePdfDocument(spectItems.fileName);
                }}
              >
                <img src={UploadDummy} alt="upload Dummy" />
                <span>{spectItems.orignalFileName}</span>
              </UploadSpec>
            </Tooltip>
          ))}
        </>
      );
    }
  };
  let bidCloseTimeUTC = false;
  if (response?.postPreferences?.bidCloseTimeEpocSeconds - Date.now() / 1000 > 0) {
    bidCloseTimeUTC = true;
  }
  return (
    <>
      {loaderVisible && <Spinner />}
      {response && (
        <div className={styles.textSection}>
          <Description>
            <div className="product-header-sec">
              <img
                src={RightArrow}
                alt="RightArrow"
                className="right-arrow"
              />
              <div className="product-header-title">
                <Title>
                  {/* {response?.orderRecurrence || response?.postRecurrence ? response?.postTitle.split('-Lot')[0] : response?.postTitle} */}
                  {response?.postTitle}
                  <PrivatePost className="">
                    {response?.postPreferences?.postingMethod !== "MARKET" && "Private Post"}
                  </PrivatePost>
                  <span
                    hidden={!response?.orderRecurrence}
                    className={styles.purple}
                  >
                    {response?.orderRecurrence && 'Recurring Order'}
                  </span>
                </Title>
                <SubTitle>{response?.comments}</SubTitle>
              </div>
              <ProductHeaderReseller>

                {/* {(response?.orderRecurrence || !response?.postRecurrence) && (
                  <>
                    <span hidden className={styles.purple}>
                    {response?.postRecurrence? 'Recurring Post':'Recurring Order'}
                    </span>
                  </>
                )} */}

                {response?.postedUserDetails?.userRole === "BROKER" && (
                  <SellerIconWrapper>
                    <div>
                      <img src={reseller} alt="reseller" />
                      <p style={{ lineHeight: "10px" }}>
                        {pageLanguageContents?.PalletDetails[0]?.Reseller}
                      </p>
                    </div>
                  </SellerIconWrapper>
                )}

                <StarIconWrapper>
                  <div>
                    <img
                      src={premium_star}
                      hidden={!response?.postedUserDetails?.fcMember}
                      alt="premium_star"
                    />
                  </div>
                </StarIconWrapper>

              </ProductHeaderReseller>
            </div>
          </Description>
          <InnerWrapper>
            <div className={styles.imageSection}>
              <div
                className={`${response?.postType !== "NEED"
                  ? styles.productImage
                  : styles.productImageDark
                  } d-none d-md-block`}
              >
                <PalletsWrapper>
                  <Pallets>
                    <div className={`d-inline-flex pallete-image p-2 ${response?.postType !== "NEED"
                      ? styles.borderLightBlue
                      : styles.borderDarkBlue
                      }`}>
                      <img
                        src={
                          response?.postImageFiles && response?.postImageFiles.length > 0
                            ? `${fileUrl}${response?.postImageFiles[0]?.fileName}`
                            : PalletsImg
                        }
                        alt="Pallets"
                      />
                    </div>
                  </Pallets>
                </PalletsWrapper>
              </div>

              <div className={styles.sellerInfo}>
                <div>
                  {/* {response?.postedUserDetails?.userRole ==="BROKER" ? (
                    <h6>Delivery Zip Code:</h6>
                  ) : (
                    <h6>Buyer Located Near:</h6>
                  )} */}
                  <h6>Buyer Located Near:</h6>
                  <p onClick={() => addTofavorite(response)}>
                    {'Favorite'}{" "}
                    &nbsp;
                    {response?.favorite ? (
                      <FavoriteIcon style={{ color: "#cd181d" }} />
                    ) : (
                      <FavoriteBorderOutlinedIcon />
                    )}
                  </p>
                </div>
                <div className={styles.info}>
                  <address>
                    {/* {response?.postedUserDetails?.userRole ==="BROKER" ?
                        <p>
                          {
                            pageLanguageContents?.PalletDetails[4]?.ZipCode
                          }{" "}
                          {response?.shippingAddress?.zipCode}
                        </p>:
                        <>
                          <h6 hidden={!response?.innerCircle} >
                          {response?.shippingAddress?.locationName}
                          </h6>                              
                        
                          <h5 hidden={response?.innerCircle} style={{"font-weight":"bold"}}>
                            {response?.shippingAddress?.locationName}
                          </h5>                              
                        
                          <p>
                            {response?.shippingAddress?.address1}&nbsp;
                          </p>
                          <p>
                            {response?.shippingAddress?.address2}
                          </p>                              
                        
                          <p>
                            {response?.shippingAddress?.city},&nbsp;
                            {response?.shippingAddress?.stateAbv}&nbsp;
                            {response?.shippingAddress?.zipCode}
                          </p>
                        </>}*/}
                    <p>
                      {response?.shippingAddress?.city},&nbsp;
                      {response?.shippingAddress?.stateAbv}&nbsp;
                      {response?.shippingAddress?.zipCode}
                    </p>
                  </address>

                  <div className={styles.checkboxContainer}>
                    <p>Operating Days-&nbsp;</p>
                    {dayOfWeeks?.map((value, i) => (
                      <p style={{ color: "#30698d" }} key={i}>
                        {value}
                        {dayOfWeeks.length - 1 !== i && ","}&nbsp;
                      </p>
                    ))}
                  </div>

                  <div className={styles.checkboxContainer}>
                    <p>Operating Hours-&nbsp;</p>
                    {response?.shippingAddress?.locationOfficeHourStart ? <p>
                      {tConvert(response?.shippingAddress?.locationOfficeHourStart)}
                      {response?.shippingAddress?.locationOfficeHourEnd ? "- " + tConvert(response?.shippingAddress?.locationOfficeHourEnd) : ''}
                    </p> : <p>
                      {tConvert(response?.appointmentStartTime)}
                      {response?.appointmentEndTime ? "- " + tConvert(response?.appointmentEndTime) : ''}
                    </p>}
                  </div>

                  {ratingSection()}

                </div>
              </div>
            </div>
            <TextInnerSection>
              <div className="d-block d-md-none">
                <PalletsWrapper>
                  <Pallets>
                    <div>
                      <img
                        src={
                          response?.postImageFiles && response?.postImageFiles.length > 0
                            ? `${fileUrl}${response?.postImageFiles[0]?.fileName}`
                            : PalletsImg
                        }
                        alt="Pallets"
                      />
                    </div>
                  </Pallets>
                </PalletsWrapper>
              </div>

              <div className={styles.condition}>
                <div>
                  {condition.length === 1 && <h3>{capitalize(condition[0].toLowerCase())} {newConditionType && newConditionType}</h3>}
                  {condition.length === 2 && (
                    <h3>{capitalize(condition[0].toLowerCase()) + "," + capitalize(condition[1].toLowerCase())} {newConditionType && newConditionType}</h3>
                  )}
                  {condition.length === 3 && (
                    <h3>
                      {capitalize(condition[0].toLowerCase()) +
                        "," +
                        capitalize(condition[1].toLowerCase()) +
                        "," +
                        capitalize(condition[2].toLowerCase())} {newConditionType && newConditionType}
                    </h3>
                  )}
                  {condition.length === 0 && (
                    <h3>
                      {pageLanguageContents?.PalletDetails[15]?.NA}
                    </h3>
                  )}
                  <p>
                    {pageLanguageContents?.PalletDetails[9]?.Condition}
                  </p>
                </div>

                {getCommodity()}
                {gradeSize()}
                {getGradeName()}
                {isHeatTreared()}

                {response?.postType !== "NEED" && (
                  <div className="pl-md-2 pl-sm-0">
                    {deliveryAvailableAttach()}
                    <p>Delivery Mode</p>
                  </div>
                )}
              </div>


              <PriceSection>
                <PriceSectionBox>
                  <>
                    <div className="flow-column">
                      {requestDateAttach()}
                    </div>
                    {response?.shippingMode === 'DELIVERY' && <div className="flow-column" hidden={!dropLive}>
                      {dropLiveAttach()}
                      <p>
                        {pageLanguageContents?.PalletDetails[35]?.Mode}
                      </p>
                    </div>}
                    <div className="flow-column">
                      {response?.vehiclePreferences ? (
                        <h3>
                          {vehiclePreferencesFun(
                            response?.vehiclePreferences
                          )}
                        </h3>
                      ) : (
                        <h3>Pickup</h3>
                      )}
                      <p>
                        {pageLanguageContents?.PalletDetails[33]?.DeliveryMode}
                      </p>
                    </div>
                    <div className="flow-column">
                      <>
                        {response?.displayCostToMarket &&
                          response?.targetPrice ? (
                          <>
                            <h3>
                              <CurrencyFormat
                                value={response?.targetPrice.toFixed(2)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                              &nbsp;
                              <PerPalletsText
                                className={styles.perPallet}
                              >
                                <span>
                                  {pageLanguageContents?.PalletDetails[14]?.PerPallet}
                                </span>
                              </PerPalletsText>
                            </h3>
                          </>
                        ) : (
                          <h3>
                            {pageLanguageContents?.PalletDetails[15]?.NA}
                          </h3>
                        )}
                      </>
                      <p>
                        {pageLanguageContents?.PalletDetails[17]?.TargetPrice}
                      </p>
                    </div>
                  </>
                </PriceSectionBox>

                <PriceSectionBox>
                  <div>
                    {response && (
                      <h3>
                        {response?.quantity.toLocaleString()}&nbsp;
                        {response?.lotDetails?.lotPostingOption === "SINGLE" && <LotsText>
                          <>
                            ({response?.lotDetails?.totLots}{" "}
                            {pageLanguageContents?.PalletDetails[19]?.Lot}
                            )
                          </>
                        </LotsText>}
                      </h3>
                    )}
                    <p>
                      {pageLanguageContents?.PalletDetails[21]?.Quantity}
                    </p>
                  </div>
                  {bidCloseTimeUTC && (
                    <div>
                      <h3>
                        {
                          <Timmer
                            time={
                              response?.postPreferences?.bidCloseTimeEpocSeconds - Date.now() / 1000
                            }
                          />
                        }
                      </h3>
                      <p>
                        {pageLanguageContents?.PalletDetails[22]?.TimeLeft}
                      </p>
                    </div>
                  )}
                </PriceSectionBox>
                {specficationDocFiles()}

                {bidCloseTimeUTC && !response?.bidAlreadyMade ?
                  <ActionSection>
                    {postLoadBtns()}
                  </ActionSection>
                  : response?.bidAlreadyMade ? <ActionSection>
                    <p>Bid Already Made</p>
                  </ActionSection> : <ActionSection>
                    <p></p>
                  </ActionSection>}
              </PriceSection>

              <>
                <TimeSection>
                </TimeSection>
                <TimeSection>
                  <div className="flow-column">
                    {deliveryAppointment()}
                  </div>
                </TimeSection>
              </>
              {response?.orderRecurrence && recurrenceTag()}
            </TextInnerSection>
          </InnerWrapper>
        </div>
      )}

      {response && (
        <RecurrenceModal
          isOpen={recurrenceModal}
          toggle={toggleRecurrenceModal}
          response={response}
          title="Recurrence"
        />
      )}

      {response && (
        <PlaceBid
          isOpen={placeBidModal}
          toggle={togglePlaceBidModal}
          response={response}
          title={
            response?.postType !== "NEED"
              ? pageLanguageContents?.PalletDetails[23]?.PlaceBid
              : "Make Bid"
          }
          link="/"
          myPostType={postType}
          apiCallBack={(val) => {
          }}
        />
      )}

      {response && makeOfferModal && (//myPostType && 
        <PlaceAltBid
          isOpen={makeOfferModal}
          toggle={toggleMakeOfferModal}
          response={response}
          myPostType={postType}
          recurring={
            response?.orderRecurrence
              ? response?.orderRecurrence
              : response?.postRecurrence
                ? response.postRecurrence
                : ""
          }
          title={pageLanguageContents?.PalletDetails[26]?.MakeOffer}
          link="/"
        />
      )}

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
};

export default NeedDetails;

const Pallets = styled.div`
  text-align: center;
  background: #fff;
  padding: 0.5rem;
  > div {
    justify-content: center;
    display: flex;
    align-items: center;
    img {
      /* width: auto;
      max-height: 191px;
      max-width: 100%; */
      object-fit: contain;
      height: 240px;
      width: 260px;
      max-width: 100%;
    }
  }
  > pallete-img {
    border: 1px solid red;
    display: inline-flex;
    align-items: center;
    padding: 0.5rem;
  }
`;
const PalletsWrapper = styled.div``;
const RatingSection = styled.div`
  font-family: "latoregular";
  display: flex;
  flex-direction: column;
  .MuiBox-root {
    margin-bottom: 0;
  }
`;
const Title = styled.h2`
  font-size: 24px;
  color: #717171;
  font-family: "latobold";
  text-align: left;
  line-height: 27px;
  margin-bottom: 10px;
  padding-top: 13px;
  display: flex;
  align-items: center;
  gap: 0 10px;
  flex-wrap: wrap;
`;
const SubTitle = styled.p`
  font-size: 12px;
  color: #717171;
  font-family: "latoregular";
  margin: 0;
  word-break: break-all;
`;
const PrivatePost = styled.p`
  background: #ff6008;
  font-size: 12px;
  line-height: 1.67;
  color: #ffffff;
  padding: 0 6px;
  width: 78px;
`;

const Description = styled.div`
  position: relative;
  padding-left: 62px;
  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
  }
`;
const SellerIconWrapper = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  p {
    margin: 0;
    line-height: 12px;
  }
`;
const StarIconWrapper = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  p {
    margin: 0;
    line-height: 12px;
  }
`;

const PriceSection = styled.div`
  padding: 0px 0 28px;
  border-bottom: solid 1px #e1e1e1;
  margin-bottom: 13px;
  background: #fff;
  color: #717171;
`;
const PriceSectionBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-flow: row;
  grid-gap: 25px 0;
  margin-bottom: 15px;
  @media (max-width: 767px) {
    grid-template: none;
    margin-bottom: 5px;
    gap: 10px;
    > div {
      display: grid;
      grid-template-columns: 50% 1fr;
      gap: 5px 10px;
      align-items: self-start;
      h3 {
        font-size: 16px;
        grid-area: 1 / 2 / 2 / 3;
      }
      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }
  h3 {
    font-size: 17px;
    font-family: "latosemibold";
    display: flex;
    align-items: center;
    line-height: 24px;
  }
  p {
    font-size: 12px;
    font-family: "latoregular";
    color: #717171;
    margin-bottom: 0;
    margin-top: 2px;
  }
`;
const ActionSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  margin-top: 29px;
  p {
    width: 150px;
  }
  button {
    padding: 8px 10px;
    width: 100%;
    font-size: 17px;
    border: none;
    font-family: "latoregular" !important;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    button {
      font-size: 14px;
    }
  }
`;
const TimeSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  padding: 15px 0;
  background: #fff;
  @media (max-width: 767px) {
    padding-bottom: 0;
    grid-auto-flow: unset;
    gap: 10px;
  }
  h3 {
    font-size: 16px;
    font-family: "latosemibold";
    color: #717171;
  }
  p {
    font-size: 12px;
    font-family: "latoregular";
    color: #717171;
    margin: 0;
    line-height: 27px;
  }
  & > div {
    display: flex;
    @media (max-width: 767px) {
      display: grid;
      grid-template-columns: 30px 1fr;
      gap: 10px;
      &.flow-column {
        grid-template-columns: 1fr 1fr;
        h3 {
          order: 2;
          font-size: 16px;
        }
        p {
          font-size: 16px;
          line-height: 1;
        }
      }
    }
    &.flow-column {
      flex-direction: column;
    }
    .icon-col {
      width: 26px;
      margin-right: 8px;
      &.distance-col {
        max-width: 18px;
      }
      img {
        max-width: 100%;
      }
    }
    .d-text {
      max-width: 190px;
      @media (max-width: 767px) {
        max-width: none;
      }
    }
  }
  @media (max-width: 767px) {
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 13px;
    }
  }
`;

const PerPalletsText = styled.small`
  color: #717171;
  line-height: 24px;
  font-size: 16px;
  font-family: "latosemibold";

  @media (max-width: 767px) {
    font-size: 11px;
  }
`;
const LotsText = styled.small`
  line-height: 24px;
  color: #ff7f00;
  font-family: "latosemibold";

  @media (max-width: 767px) {
    font-size: 11px;
  }
`;

const InnerWrapper = styled.div`
  display: grid;
  grid-template-columns: 285px 1fr;
  grid-gap: 30px;
  margin-top: 24px;

  @media (max-width: 1250px) {
    grid-template-columns: 233px 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-gap: 0;
    > div:first-child {
      order: 2;
    }
  }
`;
const TextInnerSection = styled.div``;
const UploadSpec = styled.div`
  display: flex;
  align-items: center;
  align-items: flex-start;
  img {
    margin-right: 5px;
  }
`;

const ProductHeaderReseller = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
